import { sharedActions } from './';
import sharedServices from './services';
import {
    call,
    put,
    takeEvery,
    throttle
} from 'redux-saga/effects';

function* _actionThrottle ({ payload: { action, args } }) {
    yield put(action(args));
}

function* _sendError ({ payload }) {
    try {
        yield call(sharedServices.sendError, null, payload);
    } catch (e) {
    
    }
}

export default [
    throttle(2000, sharedActions.actionThrottle.type, _actionThrottle),
    takeEvery(sharedActions.sendError.type, _sendError)
];
